export interface LookupTnExampleProps {
  header: string;
  description: string;
  exampleResponse: string;
  italicsEnding?: string;
}

export const LOOKUP_TN_EXAMPLES: LookupTnExampleProps[] = [
  {
    header: "Landline Number",
    description:
      "1787227xxxx – This is an AT&T number, it has never been ported. The Industry NNID is 101851 (AT&T), it is a PR (Puerto Rico ) country number, it is fixed and has originally been assigned to the same code range provider of NNID 101851.  It is not a Business (A2P) number.",
    italicsEnding: "(Landline AT&T number)",
    exampleResponse: `{
    "name": "AT&T, Inc. - PR",
    "tel": "+1787227xxxx",
    "cic": "+101851",
    "iso2": "PR",
    "type": "Fixed",
    "cr": "101851"
}`,
  },
  {
    header: "Mobile Number",
    description:
      "1201214xxxx - This is a T-mobile number, it has been ported. The Industry NNID is 100335 (you can find within the GCMR), it is a US country number, it is mobile, it was originally assigned to the code range provider of NNID 100321(AT&T).  It has been ported and it is not a Business (A2P) number.",
    italicsEnding: "(T-mobile number ported from another provider)",
    exampleResponse: `{
      "name": "T-Mobile USA, Inc.", 
      "pi": true,
      "tel": "+1201214xxxx",
      "cic": "+100335",
      "iso2": "US",
      "type": "Mobile",
      "cr": "100321"
}`,
  },
  {
    header: "SMS Enabled Landline Number - Personal P2P",
    description:
      "1989966xxxx – This is a Google Voice number, it has been ported (voice hosting on one network and SMS hosting on another network). The nnSR NNID is 102793 (GOOGLE VOICE), it is a US country number, it is fixed, it was originally assigned to the code range provider of NNID 102347 (BANDWIDTH) and the Industry NNID is 102347 (BANDWIDTH).  It is not a Business (A2P) number.",
    italicsEnding:
      "(Landline text enabled Google Voice number that is being run by Bandwidth)",
    exampleResponse: `{
    "spsr": "+102347",
    "type": "Fixed",
    "cr": "102347",
    "name": "Google (Grand Central) - SVR",
    "pi": true,
    "tel": "+1989966xxxx",
    "cic": "+102793",
    "iso2": "US"
}`,
  },
  {
    header: "SMS Enabled Landline Number - Business A2P",
    description:
      "1415483xxxx - This is a Twilio number, it has been ported. The nnSR NNID is 103704 (Twilio - SMS/MMS-SVR), it is a US country number, it is fixed, was originally assigned to the code range provider of NNID 100419(LEVEL3). It has been ported.  Industry NNID is 104085 (Twilio International, Inc.) and the nnSR NNID is 103704(Twilio - SMS/MMS-SVR). It is an A2P number with the campaign code of CKWRBU3.",
    italicsEnding:
      "(Text enabled landline number, with voice hosting on one network and SMS hosting on another network for Business (A2P))",
    exampleResponse: `{
    "spsr": "+104085",
    "type": "Fixed",
    "cr": "100419",
    "name": "Twilio - SMS/MMS-SVR",
    "pi": true,
    "tel": "+1415483xxxx",
    "cic": "+103704",
    "iso2": "US",
    "campaign_id": "CKWRBU3"
}`,
  },
];
